import { useQuery } from '@tanstack/vue-query'
import Interview from '@/api/Dara/Interview'
import { interviewKeys } from '@/composable/queries/keys'

export const useUpcomingInterviewsQuery = (
  studentId: Ref<number>,
  enabled: Ref<boolean> = ref(true),
) =>
  useQuery({
    queryKey: interviewKeys.interviews(studentId),
    queryFn: () => Interview.getUpcomingInterviews(studentId.value),
    enabled,
  })

export const useInterviewQuery = (
  studentId: Ref<number>,
  interviewId: Ref<number>,
  enabled: Ref<boolean> = ref(true),
) =>
  useQuery({
    queryKey: interviewKeys.interview(studentId, interviewId),
    queryFn: () => Interview.getInterview(interviewId.value),
    enabled,
  })
